export default __webpack_public_path__ + "static/pencils-df397a4e37ca2e95da43a5a95a056683.jpg";